import { useTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

import type { WidgetThemeWithScale } from './createWidgetTheme';

export interface WidgetBrandColors {
  gradient: { from: string; to: string; foreground: string };
  primaryOnPaper: string;
}

export function getWidgetBrandColorsFromTheme(theme: Theme): WidgetBrandColors {
  const widgetTheme = theme as WidgetThemeWithScale;

  return (
    widgetTheme.widgetBrand ?? {
      gradient: {
        from: theme.palette.primary.main,
        to: theme.palette.secondary.main,
        foreground: theme.palette.primary.contrastText,
      },
      primaryOnPaper: theme.palette.primary.main,
    }
  );
}

export function useWidgetBrandColors(): WidgetBrandColors {
  const theme = useTheme();
  return getWidgetBrandColorsFromTheme(theme);
}
